<span class="shrink-0 items-center" [class.flex]="!middleFills()" [class.hidden]="middleFills()">
  <ng-content select="[mibHeaderBrand]" />
</span>

<div class="flex min-w-0 flex-1 items-center self-stretch">
  <ng-content />
</div>

@if (endRule() && end()) {
  <span class="h-6 w-px shrink-0 bg-mib-hairline" [class.hidden]="middleFills()" aria-hidden="true"></span>
}

<span class="shrink-0 items-center" [class.flex]="!middleFills()" [class.hidden]="middleFills()">
  <ng-content select="[mibHeaderEnd]" />
</span>
